module.exports = __webpack_public_path__ + "packs/media/images/palestraVie2-16bd77b5bde3412d42ab66abe31bb569.jpg";